import { render, staticRenderFns } from "./NewPlatformNotice.vue?vue&type=template&id=61ff9538"
import script from "./NewPlatformNotice.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewPlatformNotice.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports